import styled from 'styled-components';

import Button from 'components/Button/Button';

const TrelloModalContainer = styled(Button)`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.36);
  z-index: 10000000;
  margin: 0;
  cursor: default;

  .container {
    width: 550px;
    background-color: #fff;
    border-radius: 4px;
    overflow: hidden;

    .banner {
      height: 250px;
      background-image: url('/assets/img/trello-successful.png');
      background-size: 350px;
      background-repeat: no-repeat;
      background-position: center 79px;
      background-color: ${({ theme }) => theme.colors.grey2};

      &.asana {
        background-image: url('/assets/img/asana.png');
      }

      &.zapier {
        background-image: url('/assets/img/zapier-integration.png');
        background-size: 200px;
        background-position: center;
      }
    }

    .content {
      padding: 40px 50px;
      text-align: center;

      h2 {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 0;
        font-size: 24px;

        .icon {
          display: inline-block;
          width: 24px;
          height: 24px;
          background-color: ${({ theme }) => theme.colors.teal};
          border-radius: 50%;
        }
      }

      p {
        margin-bottom: 23px;
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        opacity: 0.6;
      }

      button {
        padding: 5px 40px;
        font-size: 14px;
        line-height: 36px;
      }
    }
  }
`;

export default TrelloModalContainer;
